import styled from '@emotion/styled';
import { BASE_COLORS } from "../../constants/Theme";
export const AnalyticsContainer = styled.div `
	display: flex;
	flex-wrap: wrap;
	row-gap: 16px;
	align-items: center;
	justify-content: space-evenly;

	${(props) => (props.width ? `width: ${props.width}` : 'width: 280px')};
	background: ${(props) => props.mode == 'light'
    ? BASE_COLORS.grayscale['100']
    : BASE_COLORS.brand['900']};
	padding: 26px 12px 16px 12px;
	border-radius: 0 0 8px 8px;

	.analytics__card:nth-child(n + 4) {
		${(props) => props.count == 5
    ? 'flex-basis: 48%'
    : props.count == 6 || props.count == 7
        ? 'flex-basis: 31%'
        : props.count == 8
            ? 'flex-basis: 23%'
            : ''};
	}

	.analytics__card:nth-child(4) {
		${(props) => (props.count == 7 ? 'flex-basis: 23% !important' : '')}
	}

	.shimmers {
		display: flex;
		gap: 8px;
		.shine {
			margin-top: 2px !important;
		}
	}
`;
export const CardDataContainer = styled.div `
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	row-gap: 4px;

	flex-grow: 1;
	flex-shrink: 0;
	flex-basis: ${(props) => props.count == 2
    ? '48%'
    : props.count == 3
        ? '31%'
        : props.count == 4
            ? '23%'
            : props.count == 5
                ? '31%'
                : props.count == 6
                    ? '31%'
                    : props.count == 7
                        ? '23%'
                        : props.count == 8
                            ? '23%'
                            : 'auto'};

	.category,
	.statistic {
		max-width: 100%;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}
`;
//# sourceMappingURL=AnalyticsCard.styled.js.map